import { createUseContext } from '@boxcryptor-web/shared/react-hooks';
import * as React from 'react';
import { InternalLinkProps } from './InternalLink';

export type InternalLinkReplacement = string;
export type InternalLinkReplacements = Record<string, InternalLinkReplacement>;
export type InternalLinkContext = {
  internalLinkComponent: React.FC<InternalLinkProps>;
  baseUrl: string;
  shouldRenderAsInternalLink: (to: string) => boolean;
  getReplacedInternalLink: (to: string) => string;
};

const InternalLinkContext = React.createContext<InternalLinkContext | undefined>(undefined);

export const useInternalLinkContext = createUseContext('InternalLinkContext', InternalLinkContext);

export const InternalLinkContextProvider = InternalLinkContext.Provider;
